import { render } from "./Menu.vue?vue&type=template&id=38b9aa8c&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=38b9aa8c&scoped=true&lang=scss"
import "./Menu.vue?vue&type=style&index=1&id=38b9aa8c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b9aa8c"]])

export default __exports__